import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  EVBox,
  EVExpandLess,
  EVExpandMore,
  EVIconButton,
  EVTooltip,
} from '@eagleview/ev-comp-library';
import { inRange } from 'lodash';
import clsx from 'clsx';
import useStyles from './FullscreenToggleButtonStyle';
import { SHOW_TOGGLE_BUTTON_TRIGGER_HEIGHT, TOGGLE_BUTTON_WIDTH } from './FullscreenToggleButton.constants';

const FullscreenToggleButton = (props) => {
  const {
    shouldHeaderRender, toggleFullscreen, showNewUI, mfaList,
  } = props;

  const [showIcon, setShowIcon] = useState(shouldHeaderRender);
  const classes = useStyles({ width: TOGGLE_BUTTON_WIDTH, showIcon });

  useEffect(() => {
    setShowIcon(shouldHeaderRender || showIcon);
  }, [shouldHeaderRender]);

  const setFullScreen = (fullscreen) => {
    toggleFullscreen({ hideSidebar: (showNewUI && mfaList.length === 1) || fullscreen, hideHeader: fullscreen });
  };

  const handleMouseMove = (event) => {
    if (shouldHeaderRender) return;
    const { clientX, clientY } = event;
    const inRangeX = inRange(clientX, ((window.innerWidth / 2) - (TOGGLE_BUTTON_WIDTH / 2)), ((window.innerWidth / 2) + (TOGGLE_BUTTON_WIDTH / 2)));
    const inRangeY = inRange(clientY, 0, SHOW_TOGGLE_BUTTON_TRIGGER_HEIGHT);
    setShowIcon(inRangeX && inRangeY);
  };

  useEffect(() => {
    if (shouldHeaderRender) {
      window.removeEventListener('mousemove', handleMouseMove);
    } else {
      window.addEventListener('mousemove', handleMouseMove);
    }
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [shouldHeaderRender]);

  return (
    <EVBox
      className={classes.fullscreenToggleButtonContainer}
    >
      <EVTooltip title={shouldHeaderRender ? 'Hide Navigation' : 'Show Navigation'}>
        <EVIconButton
          id="fullscreen-btn"
          className={clsx(
            classes.FullscreenToggleButton,
          )}
          disableRipple
          onClick={() => {
            setFullScreen(shouldHeaderRender);
          }}
        >
          {shouldHeaderRender
            ? (
              <>
                <div id="less_1" className={classes.iconLess1}><EVExpandLess className={classes.icon} /></div>
                <div id="less_2" className={classes.iconLess2}><EVExpandLess className={classes.icon} /></div>
              </>
            )
            : (
              <>
                <div id="more_1" className={classes.iconMore1}><EVExpandMore className={classes.icon} /></div>
                <div id="more_2" className={classes.iconMore2}><EVExpandMore className={classes.icon} /></div>
              </>
            )}
        </EVIconButton>
      </EVTooltip>
    </EVBox>
  );
};

FullscreenToggleButton.propTypes = {
  shouldHeaderRender: PropTypes.bool.isRequired,
  toggleFullscreen: PropTypes.func.isRequired,
  showNewUI: PropTypes.bool.isRequired,
  mfaList: PropTypes.arrayOf(
    PropTypes.shape({
      appId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      rootUrl: PropTypes.string.isRequired,
      prefetch: PropTypes.bool,
    }),
  ).isRequired,
};

export default FullscreenToggleButton;
